import React, { useState } from "react";
import AppRouter from "./router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Loader from "./Components/Loader/Loader";
import FixedIcons from "./Components/FixedIcon";

const queryClient = new QueryClient();

const App = () => {
  const [loading] = useState(false);

  return (
    <QueryClientProvider client={queryClient}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        {loading && <Loader />}
         <FixedIcons />
        <AppRouter />
      </LocalizationProvider>
    </QueryClientProvider>
  );
};

export default App;
